import React from 'react';
import styled from 'styled-components';
import {Paper} from '@material-ui/core';

const Styled = styled(Paper)`
width: 100%;
padding: 20px;
`;

const StyledPaper = (props: any) => {
  return <Styled elevation={2}>{props.children}</Styled>;
};

export default StyledPaper;
